<div>
  <p class="form-section-heading">
    <strong>{{ gradingTitle | translate }}</strong>
  </p>
  <div>
    <form [formGroup]="gradingFormGroup">
      <div class="form-row">
        @if (!isPalateTreatment) {
        <div class="form-columns-1-1">
          <stx-radio-group
            class="half-width-responsive"
            [layoutDirection]="'column'"
            [controlName]="'preGrade'"
            [formGroup]="gradingFormGroup"
            [formMode]="formMode"
            [options]="preGrades"
          ></stx-radio-group>
          <stx-radio-group
            class="half-width-responsive"
            [layoutDirection]="'column'"
            [controlName]="'postGrade'"
            [formGroup]="gradingFormGroup"
            [formMode]="formMode"
            [options]="postGrades"
          ></stx-radio-group>
        </div>
        } @else {
        <stx-radio-group
          class="half-width-responsive"
          [layoutDirection]="'column'"
          [controlName]="'postGrade'"
          [formGroup]="gradingFormGroup"
          [formMode]="formMode"
          [options]="failPassGrades"
        >
        </stx-radio-group>
        }
      </div>

      <hr class="form-subsection-separator" />
      <div class="form-row">
        <div class="checkbox-group">
          <stx-checkbox
            [name]="'surgical_qa_panel.surgery_was_unnecessary'"
            [controlName]="'surgeryWasUnnecessary'"
            [formGroup]="gradingFormGroup"
            [formMode]="formMode"
          ></stx-checkbox>
          <stx-checkbox
            [name]="'surgical_qa_panel.surgical_results_not_evident'"
            [controlName]="'surgicalResultsNotEvident'"
            [formGroup]="gradingFormGroup"
            [formMode]="formMode"
          ></stx-checkbox>
          <stx-checkbox
            [name]="'surgical_qa_panel.quality_of_photos_too_poor'"
            [controlName]="'qualityOfPhotosTooPoor'"
            [formGroup]="gradingFormGroup"
            [formMode]="formMode"
          ></stx-checkbox>
        </div>
      </div>
      <div class="form-row">
        <stx-checkbox
          [name]="'surgical_qa_panel.alert_smile_train'"
          [controlName]="'alertSmileTrain'"
          [formGroup]="gradingFormGroup"
          [formMode]="formMode"
        ></stx-checkbox>
      </div>
      <div class="form-row">
        <stx-textarea
          [label]="'surgical_qa_panel.comments_to_share_with_st'"
          [isOptional]="!isAlertSmileTrainSelected"
          [formGroup]="gradingFormGroup"
          [formMode]="gradingFormGroup.value.alertSmileTrain ? formMode.EDIT : formMode.READONLY"
          [controlName]="'note'"
        ></stx-textarea>
      </div>
      <div class="form-row flex-row-container align-justify layout-align-center">
        <stx-action-buttons
          [noMargin]="true"
          [showSecondary]="false"
          [asyncPrimaryAction]="onSurgicalReviewSubmitted"
          [primaryText]="'save' | translate"
        ></stx-action-buttons>
        <div>{{ numberOfPendingCasesForReviewer }} {{ 'surgical_qa_panel.pending_cases' | translate }}</div>
      </div>
    </form>
  </div>
</div>
